<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="140px"
    class="oss-config"
  >
    <el-form-item
      label="储存类型"
      prop="type"
    >
      <el-radio
        :disabled="formData.id ? true: false"
        v-model="form.type"
        :label="1"
      >七牛</el-radio>
      <el-radio
        :disabled="formData.id"
        v-model="form.type"
        :label="2"
      >阿里云</el-radio>
      <el-radio
        :disabled="formData.id"
        v-model="form.type"
        :label="3"
      >腾讯云</el-radio>
    </el-form-item>
    <el-form-item
      prop="domain"
      label="域名"
    >
      <el-input
        :placeholder="`${name}绑定的域名`"
        v-model="form.domain"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="sufxi"
      label="路径前缀"
    >
      <el-input
        placeholder="不设置默认为空"
        v-model="form.sufxi"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 1"
      prop="accessKeyId"
      label="AccessKeyId"
    >
      <el-input
        :placeholder="`${name}AccessKeyId`"
        v-model="form.accessKeyId"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 1"
      prop="secretKey"
      label="SecretKey"
    >
      <el-input
        :placeholder="`${name}secretKey`"
        v-model="form.secretKey"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 1"
      prop="bucketName"
      label="空间名"
    >
      <el-input
        :placeholder="`${name}存储空间名`"
        v-model="form.bucketName"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 2"
      prop="endPoint"
      label="EndPoint"
    >
      <el-input
        :placeholder="`${name}EndPoint`"
        v-model="form.endPoint"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 2"
      prop="accessKeyId"
      label="AccessKeyId"
    >
      <el-input
        :placeholder="`${name}AccessKeyId`"
        v-model="form.accessKeyId"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 2"
      prop="secretKey"
      label="AccessKeySecret"
    >
      <el-input
        :placeholder="`${name}AccessKeySecret`"
        v-model="form.secretKey"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 2"
      prop="bucketName"
      label="BucketName"
    >
      <el-input
        :placeholder="`${name}BucketName`"
        v-model="form.bucketName"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 3"
      prop="appid"
      label="Appid"
    >
      <el-input
        type="number"
        :placeholder="`${name}Appid`"
        v-model="form.appid"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 3"
      prop="secretId"
      label="SecretId"
    >
      <el-input
        :placeholder="`${name}SecretId`"
        v-model="form.secretId"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 3"
      prop="secretKey"
      label="SecretKey"
    >
      <el-input
        :placeholder="`${name}SecretKey`"
        v-model="form.secretKey"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 3"
      prop="bucketName"
      label="BucketName"
    >
      <el-input
        :placeholder="`${name}BucketName`"
        v-model="form.bucketName"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type == 3"
      prop="bucketArea"
      label="Bucket所属地区"
    >
      <el-input
        :placeholder="`如: sh (可选值 ，华南: gz 华北: tj 华东: sh)`"
        v-model="form.bucketArea"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="status"
      label="状态"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
        v-model="form.status"
        :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
let origin = {
  type: 1,
  domain: '',
  sufxi: '',
  status: 1,
  appid: '',
  //七牛
  accessKeyId: '',
  secretKey: '',
  bucketName: '',

  //阿里云
  endPoint: '',
  // accessKeyId: '',

  //腾讯云
  secretId: '',
  // secretKey: '',
  bucketArea: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "tableForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {};
      }
    }
  },
  data() {
    return {
      dimensionList: [],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        //是否可选填参数待定 todo
        dimensionId: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        tableName: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        columnName: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        appid:[
          { required:true, message: '请输入', trigger: 'blur' },
          { max: 12, message: '长度必须少于12个字符', trigger: 'blur' }
        ]
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mixins: [formLabalPosition],
  computed: {
    name() {
      switch (this.form.type){
        case 1:
          return '七牛';
        case 2:
          return '阿里云';
        case 3:
          return '腾讯云';
      }

    }
  },
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(config){
      this.form.id = config.id;
      this.form.type = config.type;
      this.form.domain = config.domain;
      this.form.sufxi = config.prefix;
      this.form.status = config.status;
      if(this.form.type == 1){
        this.form.accessKeyId = config.accessKey;
        this.form.secretKey = config.accessSecret;
        this.form.bucketName = config.bucketName;

      }else if(this.form.type == 2){
        this.form.endPoint = config.aliyunEndPoint;
        this.form.accessKeyId = config.accessKey;
        this.form.secretKey = config.accessSecret;
        this.form.bucketName = config.bucketName;

      }else if(this.form.type == 3){
        this.form.appid = config.qcloudAppId;
        this.form.secretId = config.accessKey;
        this.form.secretKey = config.accessSecret;
        this.form.bucketName = config.bucketName;
        this.form.bucketArea = config.qcloudRegion;
      }
    },

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          let params = this.handleParams();
          this.$emit('submit',params);
        }
      })
    },
    handleParams(){
      let params = {
        type: this.form.type,
        domain: this.form.domain,
        prefix: this.form.sufxi,
        status: this.form.status,
      };
      if(this.form.id){
        params.id = this.form.id;
      }
      if(this.form.type == 1){
        params.accessKey = this.form.accessKeyId;
          params.accessSecret = this.form.secretKey;
          params.bucketName = this.form.bucketName;
      }else if(this.form.type == 2){
        //阿里云
        params.aliyunEndPoint = this.form.endPoint;
          params.accessKey = this.form.accessKeyId;
          params.accessSecret = this.form.secretKey;
          params.bucketName = this.form.bucketName;
      }else if(this.form.type == 3){
        params.qcloudAppId = this.form.appid;
          params.accessKey = this.form.secretId;
          params.accessSecret = this.form.secretKey;
          params.bucketName = this.form.bucketName;
          params.qcloudRegion = this.form.bucketArea;
      }
      return params;
    },

    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style lang="scss" scoped>
.oss-config {
  /deep/input[type="number"]::-webkit-inner-spin-button,
  /deep/input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
}
</style>
